import http from "@/utils/http";
const prefixUrl = "/Index/timezoneByKey.html";
export default {
  query(params = {}) {
    return http.get(prefixUrl, { params });
  },
};
